module.exports = __webpack_public_path__ + "static/media/banner_ciee.2471cd3e.gif";